import { z } from "zod";

export const ModifyEventSchema = z.object({
  isPrivate: z.boolean(),
  id: z.string(),
});

export const defaultModifyEventValues = {
  isPrivate: false,
  id: "",
};

export type ModifyEventForm = z.infer<typeof ModifyEventSchema>;
